import React from "react";

/**
 * Small trust row shown wherever card data or auth codes are entered.
 * Inline styles so it drops into any page without CSS wiring.
 */
const SecuredBadge = ({ style }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 6,
      color: "#6b7280",
      fontSize: 12,
      marginTop: 12,
      gridColumn: "1 / -1",
      ...style,
    }}
  >
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="4" y="10" width="16" height="11" rx="2" fill="#6b7280" />
      <path
        d="M8 10V7a4 4 0 1 1 8 0v3"
        stroke="#6b7280"
        strokeWidth="2.4"
        fill="none"
      />
    </svg>
    <span>
      Secured by <b>Flutterwave</b> · card details are encrypted
    </span>
  </div>
);

export default SecuredBadge;
